// frontend/src/components/common/EmergencyStopButton.js
import { useMemo, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

function parseCsv(value) {
  return String(value || '')
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean);
}

export default function EmergencyStopButton({ className = '' }) {
  const API = process.env.REACT_APP_API_URL;
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [lastResult, setLastResult] = useState(null);

  const canUseEmergencyStop = useMemo(() => {
    if (!user) return false;

    const allowedRoles = parseCsv(
      process.env.REACT_APP_EMERGENCY_ALLOWED_ROLES || 'admin,developer'
    );
    const allowedUsernames = parseCsv(process.env.REACT_APP_EMERGENCY_ALLOWED_USERNAMES || '');

    return allowedRoles.includes(user.role) || allowedUsernames.includes(user.username);
  }, [user]);

  if (!canUseEmergencyStop) {
    return null;
  }

  const runEmergencyStop = async () => {
    if (loading) return;

    const first = window.confirm(
      '비상정지를 실행합니다.\n\n현재 포지션은 모두 시장가로 반대매매(강제청산)되며, 자동매매는 중지됩니다.\n계속하시겠습니까?'
    );
    if (!first) return;

    const second = window.confirm(
      '최종 확인입니다.\n이 작업은 실제 주문/청산을 발생시킬 수 있습니다. 신중하게 생각해주세요.\n\n정말 비상정지를 실행하시겠습니까?'
    );
    if (!second) return;

    setLoading(true);
    setLastResult(null);
    try {
      const token = localStorage.getItem('token') || localStorage.getItem('access_token');
      const res = await axios.post(
        `${API}/emergency/stop-auto-trading`,
        null,
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
      );
      setLastResult(res.data);
      alert(
        `비상정지를 실행했습니다.\nrequest_id: ${res.data?.request_id || '-'}\n\n반드시 LS HTS/MTS에서 실제 포지션과 미체결 주문을 재확인하세요.`
      );
    } catch (e) {
      const detail = e?.response?.data?.detail ?? e?.message ?? e;
      console.error('비상정지 실패:', detail);
      setLastResult({ ok: false, detail });
      alert(
        `비상정지 실행 중 오류가 발생했습니다.\n\n${typeof detail === 'string' ? detail : JSON.stringify(detail, null, 2)}\n\n즉시 HTS/MTS 또는 브로커 화면에서 수동으로 포지션/미체결 주문을 확인하세요.`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`flex flex-col items-center gap-1 ${className}`}>
      <button
        type="button"
        onClick={runEmergencyStop}
        disabled={loading}
        className="rounded-md bg-red-700 px-4 py-2 text-sm font-bold text-white shadow hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:cursor-not-allowed disabled:opacity-60"
        title="강제청산 및 매매중지"
      >
        {loading ? '비상정지 실행중…' : '강제청산 및 매매중지'}
      </button>
      {lastResult?.request_id && (
        <div className="text-[11px] text-gray-500">ID: {lastResult.request_id}</div>
      )}
    </div>
  );
}
